import React, { useMemo } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactDataTable from 'react-data-table-component';
import {
    mastercard,
    paypal,
    visacard,
} from '../../assets/images';

export default function InvoiceReport() {

    const columnsFilter = [
        {
            name: 'Invoice Number',
            selector: row => row.invoiceNumber,
            sortable: true,
        },
        {
            name: 'Client',
            selector: row => row.client,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row.date,
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row.type,
        },
        {
            name: 'Status',
            selector: row => row.status,
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            sortable: true,
        },
    ];

    const dataFilter = [
        {
            invoiceNumber: '#LA-0218',
            client: 'vPro Infoweb LLC.',
            date: '07 March, 2021',
            type: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Approved</span>,
            amount: '$4,205'
        },
        {
            invoiceNumber: '#LA-0218',
            client: 'vPro Infoweb LLC.',
            date: '07 March, 2021',
            type: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Approved</span>,
            amount: '$4,205'
        },
        {
            invoiceNumber: '#LA-0220',
            client: 'BT Technology',
            date: '25 Jun, 2021',
            type: <img src={mastercard} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            amount: '$5,205'
        },
        {
            invoiceNumber: '#LA-0220',
            client: 'BT Technology',
            date: '25 Jun, 2021',
            type: <img src={mastercard} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            amount: '$5,205'
        },
        {
            invoiceNumber: '#LA-0222',
            client: 'Core Infoweb Pvt.',
            date: '12 July, 2021',
            type: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-yellow text-white rounded'>Pending</span>,
            amount: '$2,000'
        },
        {
            invoiceNumber: '#LA-0312',
            client: 'AUR Tech LLC.',
            date: '13 July, 2021',
            type: <img src={paypal} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Approved</span>,
            amount: '$10,000'
        },
        {
            invoiceNumber: '#LA-0389',
            client: 'Lucid Pvt.',
            date: '27 July, 2021',
            type: <img src={visacard} alt='paymrnt type' className='w-[50px]' />,
            status: <span className='inline-block py-1 px-2 uppercase text-[10.5px]/[12px] bg-success text-white rounded'>Approved</span>,
            amount: '$1,205'
        },
    ]

    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = dataFilter.filter(
        item =>
            item.invoiceNumber.toLowerCase().includes(filterText.toLowerCase()) ||
            item.client.toLowerCase().includes(filterText.toLowerCase()) ||
            item.date.toLowerCase().includes(filterText.toLowerCase()) ||
            item.amount.toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className='flex gap-5 mb-10 w-full justify-end'>
                <div className='relative w-full max-w-[221px]'>
                    <input
                        type='text'
                        id='search'
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        placeholder='Search here...'
                        className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
                    />
                </div>
                <button onClick={handleClear} className="btn btn-danger">
                    Clear
                </button>
            </div>
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <>
            <Breadcrumb title="Invoice Report" path="Report / Invoice Report" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='react-data-table'>
                    <ReactDataTable
                        columns={columnsFilter}
                        data={filteredItems}
                        pagination
                        paginationResetDefaultPage={resetPaginationToggle}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                    />
                </div>
            </div>
        </>
    )
}

